import { IconButton } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { isNotNullOrUndefined } from '@vy/utils';
import { useState } from 'react';
import { VyTableColumnSettings } from '../../../../components/new-design/table/table-column-settings/VyTableColumnSettings';
import {
  type FilterField,
  type FilterLineType,
} from '../../../../components/new-design/vyTableFilter';
import type { ColumnConfig } from '../../../../hooks/use-grid-column-settings';
import { reportIconButtonSx } from '../../reports-components/report-toolbar-styles';
import { RevenueReportToolbar } from '../../reports-components/RevenueReportToolbar';
import { NRR_GRR_MANDATORY_COLUMNS_COUNT } from '../hooks/use-nrr-grr-report-columns';

type NrrGrrReportToolbarProps = {
  fromDate: Date | null;
  onFromDateChange: (date: Date | null) => void;
  toDate: Date | null;
  onToDateChange: (date: Date | null) => void;
  filterFields: FilterField[];
  filters: FilterLineType[];
  onFiltersChange: (filters: FilterLineType[]) => void;
  onColumnSettingsOpen: () => void;
  onColumnSettingsClose: () => void;
  columnSettings: ColumnConfig[];
  onColumnVisibilityChange: (field: string, isVisible: boolean) => void;
  onExport: () => void;
  showChart: boolean;
  onShowChartChange: (show: boolean) => void;
};

export const NrrGrrReportToolbar: React.FC<NrrGrrReportToolbarProps> = ({
  fromDate,
  onFromDateChange,
  toDate,
  onToDateChange,
  filterFields,
  filters,
  onFiltersChange,
  onColumnSettingsOpen,
  onColumnSettingsClose,
  columnSettings,
  onColumnVisibilityChange,
  onExport,
  showChart,
  onShowChartChange,
}) => {
  const [columnSettingsAnchorEl, setColumnSettingsAnchorEl] = useState<HTMLButtonElement | null>(null);
  const isColumnSettingsOpen = isNotNullOrUndefined(columnSettingsAnchorEl);

  const trailingActions = (
    <>
      <IconButton
        onClick={(event) => {
          setColumnSettingsAnchorEl(event.currentTarget);
          onColumnSettingsOpen();
        }}
        data-vy="nrr-grr-report-column-settings"
        sx={reportIconButtonSx}
      >
        <VyIcon icon="Grid" style={{ transform: 'scale(0.8)' }} />
      </IconButton>

      <VyTableColumnSettings
        anchorEl={columnSettingsAnchorEl}
        open={isColumnSettingsOpen}
        onClose={() => {
          setColumnSettingsAnchorEl(null);
          onColumnSettingsClose();
        }}
        columns={columnSettings}
        handleColumnVisibilityChange={onColumnVisibilityChange}
        mandatoryColumnsCount={NRR_GRR_MANDATORY_COLUMNS_COUNT}
      />
    </>
  );

  return (
    <RevenueReportToolbar
      hideSearch
      fromDate={fromDate}
      onFromDateChange={onFromDateChange}
      toDate={toDate}
      onToDateChange={onToDateChange}
      useDateRangePicker
      filterFields={filterFields}
      filters={filters}
      onFiltersChange={onFiltersChange}
      showChart={showChart}
      onShowChartChange={onShowChartChange}
      onExport={onExport}
      trailingActions={trailingActions}
    />
  );
};
